<template>
  <div>
    <div class="sidemenu-open" v-if="checkClientWidth" :class="{'sidebar-closed':sidebarOpen}">
      <div>
        <!-- back button -->
        <div
          style="padding:10px;height:50px;border-top-right-radius: 7px;background-color: #2d2d30;border-bottom-right-radius: 7px;box-shadow: 2px 3px 15px 0px;">
          <transition name="fade">
            <a v-if="selectedSubmenuArray.length>0 || routerSubMenuActive" style="color:#fffdfc;font-size:22px;"
              @click.prevent="selectedSubmenuArray.pop();routerSubMenuActive=false"><span class="text">Atpakaļ <i
                  class="chevron left icon"></i></span></a>

          </transition>
        </div>
        <hr style="margin:0;width:97%">
        <!-- first Level menu title -->

        <!-- SubItems -->
        <div
          style="background-color: #2d2d30;border-top-right-radius: 7px;border-bottom-right-radius: 7px;box-shadow: 2px 3px 15px 0px;overflow-x:scroll">
          <div style="color:#fffdfc;font-size:22px;padding-left:10px;height:30px;">
            <transition name="fade">
              <span
                v-if="selectedSubmenuArray[selectedSubmenuArray.length-1]">{{selectedSubmenuArray[selectedSubmenuArray.length-1].category}}</span>
              <span v-else-if="routerSubMenuActive">Mani dati</span>
              <span v-else></span>
            </transition>
          </div>
          <div style="height:100vh">
            <ul class="submenu-list submenu-level1"
              :class="{'is-active':selectedSubmenuArray.length==0 && !routerSubMenuActive}">
              <li style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                <router-link :to="{name:'home'}" exact>
                  <i class="home icon"></i> Sākums
                </router-link>
              </li>
              <li v-if="user.role > 0 && user.export_to_ramus == 1" style="margin-left:-20px"
                @click="sidebarOpen=!sidebarOpen">
                <div v-if="user.role > 0 && user.export_to_ramus == 1" v-on:click="repeatLastOrder" class="item repeat-last-order">
                  <i class="repeat icon"></i>Atkārtot grozu
                </div>
              </li>

              <li v-if="user.role > 0" style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                <router-link v-if="user.role > 0" :to="{name:'waiting-for-delivery'}" exact>
                  <i class="hourglass start icon"></i>
                  Gaida piegādi <span v-if="itemsWaitingForDelivery>0"
                    style="height:100%;padding-left:8px;padding-right:8px;padding-top:3px;padding-bottom:3px;background-color:#0b87e0;border-radius:5px">{{itemsWaitingForDelivery}}</span>
                </router-link>
              </li>
              <li v-if="user.role > 0" style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                <router-link v-if="user.role > 0" :to="{name:'autoship'}">
                  <i class="retweet icon"></i> AutoShip
                </router-link>
              </li>
              <li style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                <router-link :to="{name:'goods'}">
                  <i class="shopping basket icon"></i> Preces
                </router-link>
              </li>
              <li v-for="item in mobileViewCategory" @click="menuItemClicked(item,1)">
                <a>{{item.category}}<i v-if="item.category_a.length>0" class="caret right icon"></i></a>
              </li>
              <li v-if="user.role > 0" style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                <router-link v-if="user.role > 0" :to="{name:'topup'}">
                  <i class="euro icon"></i> Papildināt kontu
                </router-link>
              </li>
              <li v-if="user.role > 0 && user.export_to_ramus == 1" style="margin-left:-20px"
                @click="routerSubMenuActive=true;selectedSubmenuArray.length=0">
                <a v-if="user.role > 0 && user.export_to_ramus == 1">
                  <i class="cog icon"></i>
                  Mani dati <i class="caret right icon"></i>
                </a>
              </li>
              <li @click="sidebarOpen=!sidebarOpen" v-if="user.role > 0" style="margin-left:-20px">
                <router-link :to="{name:'logout'}">
                  <i class="power icon"></i><span>Iziet</span>
                </router-link>
              </li>
              <li v-else style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                <router-link :to="{name:'login'}" class="right item">
                  <i class="power icon"></i> <span>Ienākt/Log-in</span>
                </router-link>
              </li>
            </ul>
            <transition name="fade">
              <ul v-if="selectedSubmenuArray[0]" class="submenu-list submenu-level2"
                :class="{'is-active':selectedSubmenuArray.length==1}">
                <li v-for="item in selectedSubmenuArray[0].category_a" @click="menuItemClicked(item,2)">
                  <a>{{item.category}}<i v-if="item.category_b.length>0" class="caret right icon"></i></a></li>
              </ul>
            </transition>
            <transition name="fade">
              <ul v-if="selectedSubmenuArray[1]" class="submenu-list submenu-level3"
                :class="{'is-active':selectedSubmenuArray.length==2}">
                <li v-for="item in selectedSubmenuArray[1].category_b" @click="menuItemClicked(item,3)">
                  <a>{{item.category}}</a></li>
              </ul>
            </transition>
            <transition name="fade">
              <ul v-if="routerSubMenuActive" class="submenu-list submenu-level3"
                :class="{'is-active':routerSubMenuActive}">
                <li style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                  <router-link :to="{name:'user-profile'}" active-class="active" class="item repeat-last-order">
                    <i class="edit icon"></i> Profila informācija
                  </router-link>
                </li>
                <li style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                  <router-link :to="{name:'user-address'}">
                    <i class="marker icon"></i> Piegādes adreses
                  </router-link>
                </li>
                <li style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                  <router-link v-if="user.export_to_ramus == 1" :to="{name:'user-rented-goods'}">
                    <i class="sticky note icon"></i>Lietošanā esošās preces
                  </router-link>
                </li>
                <li style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                  <router-link :to="{name:'user-invoices'}">
                    <i class="shopping basket icon"></i>Izpildītie pasūtījumi
                  </router-link>
                </li>
                <li style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                  <router-link v-if="user.export_to_ramus == 1" :to="{name:'user-monthly-bills'}">
                    <i class="history icon"></i> Ikmēneša rēķini
                  </router-link>
                </li>
                <li style="margin-left:-20px" @click="sidebarOpen=!sidebarOpen">
                  <router-link v-if="user.export_to_ramus == 1" :to="{name:'user-bills'}">
                    <i class="sticky note outline icon"></i> Avansa rēķini
                  </router-link>
                </li>
              </ul>
            </transition>
          </div>
        </div>
      </div>
    </div>



    <div v-else class="ui custom_brown stackable inverted menu">
      <router-link :to="{name:'home'}" active-class="active" class="item" exact>
        <i class="home icon"></i> Sākums
      </router-link>
      <div v-if="user.role > 0 && user.export_to_ramus == 1" v-on:click="repeatLastOrder" class="item">
        <i class="repeat icon"></i>Atkārtot grozu
      </div>
      <router-link :to="{name:'goods'}" active-class="active" class="item">
        <i class="shopping basket icon"></i> Preces
      </router-link>
      <router-link v-if="user.role > 0" :to="{name:'waiting-for-delivery'}" active-class="active" class="item" exact>
        <i class="hourglass start icon"></i>
        <div v-if="itemsWaitingForDelivery>0" class="floating ui green label">{{itemsWaitingForDelivery}}</div>
        Gaida piegādi
      </router-link>
      <router-link v-if="user.role > 0" :to="{name:'autoship'}" active-class="active" class="item">
        <i class="retweet icon"></i> AutoShip
      </router-link>
      <router-link v-if="user.role > 0" :to="{name:'topup'}" active-class="active" class="item">
        <i class="euro icon"></i> Papildināt kontu
      </router-link>
      <div v-if="user.role > 0 && user.export_to_ramus == 1" class="ui simple dropdown item">
        <i class="cog icon"></i>
        Mani dati
        <div class="menu">
          <router-link :to="{name:'user-profile'}" active-class="active" class="item">
            <i class="edit icon"></i> Profila informācija
          </router-link>
          <router-link :to="{name:'user-address'}" active-class="active" class="item">
            <i class="marker icon"></i> Piegādes adreses
          </router-link>
          <router-link v-if="user.export_to_ramus == 1" :to="{name:'user-rented-goods'}" active-class="active"
            class="item">
            <i class="sticky note icon"></i>Lietošanā esošās preces
          </router-link>
          <router-link :to="{name:'user-invoices'}" active-class="active" class="item">
            <i class="shopping basket icon"></i>Izpildītie pasūtījumi
          </router-link>
          <router-link v-if="user.export_to_ramus == 1" :to="{name:'user-monthly-bills'}" active-class="active"
            class="item">
            <i class="history icon"></i> Ikmēneša rēķini
          </router-link>
          <router-link v-if="user.export_to_ramus == 1" :to="{name:'user-bills'}" active-class="active" class="item">
            <i class="sticky note outline icon"></i> Avansa rēķini
          </router-link>
        </div>
      </div>
      <router-link :to="{name:'logout'}" v-if="user.role > 0" class="right item">
        <i class="power icon"></i><span>Iziet</span>
      </router-link>
      <router-link :to="{name:'login'}" v-else class="right item">
        <i class="power icon"></i> <span>Ienākt/Log-in</span>
      </router-link>

    </div>
    <a v-if="checkClientWidth" class="sidebar-menu-button" :class="{'sidebar-menu-button-closed':sidebarOpen}"
      @click.prevent="sidebarOpen=!sidebarOpen">
      <div class="hamburger" :class="{'is-active':!sidebarOpen,'hide-hamburger':!sidebarOpen}" id="hamburger-6"
        style="padding-top:3px;padding-bottom:3px;padding-left:13px;padding-right:10px;background-color:#2d2d30;border-top-right-radius: 7px;border-bottom-right-radius: 7px;box-shadow: 2px 3px 10px 0px #3a3a3a;">
        <span class="line" :class="{'line-closed':!sidebarOpen}"></span>
        <span class="line" :class="{'line-closed':!sidebarOpen}"></span>
        <span class="line" :class="{'line-closed':!sidebarOpen}"></span>
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        width: document.documentElement.clientWidth,
        sidebarOpen: true,
        selectedSubmenuArray: [],
        links: ['', '', ''],
        tempfix: true,
        routerSubMenuActive: false,
        searchTerm: ''
      }
    },
    computed: {
      user() {
        return this.$store.state.userStore.user
      },
      itemsWaitingForDelivery() {
        return this.$store.state.orderStore.items.length;
      },
      category() {
        return this.$store.state.categoryStore.items
      },
      checkClientWidth() {
        return document.documentElement.clientWidth < 768
      },
      mobileViewCategory() {
        return [{ 'category': 'Visi produkti', 'category_a': [], 'id': '' }, ...this.$store.state.categoryStore.items]
      }
    },
    watch: {
      width: function (newVal, oldVal) {
        if (newVal < 768) {
          this.checkClientWidth = true
        }

      },
      sidebarOpen: function (newVal, oldVal) {

      }
    },

    mounted: function () {
      if (localStorage.getItem("mw-token") != null && localStorage.getItem("mw-token") != '') this.$store.dispatch('loadCategory')
      //load info what is required for menu
      //this.$store.dispatch('loadOrderWaitingForDelivery');
    },
    methods: {
      repeatLastOrder: function () {

        this.$store.dispatch('repeatLastCart').then((response) => {
          this.$router.push({
            name: 'cart'
          });
        }).catch((error) => {
          //refresh cart as it might cause issues
        });
      },
      menuItemClicked(item, level) {
        let id = item.id;
        let link = item.link;
        
        //console.log(JSON.stringify(this.selectedSubmenuArray));
        this.links[level - 1] = link;
        
        if ((item.category_a && item.category_a.length > 0) || (item.category_b && item.category_b.length > 0)) {
          this.selectedSubmenuArray.push(item);
        } else {
          if (level == 2) {
            this.filterCategory('', id, '', this.links[0], this.links[1], this.links[2]);
          } else if (level == 3) {
            this.filterCategory('', '', id, this.links[0], this.links[1], this.links[2]);
          } else {
            this.filterCategory(id, '', '', this.links[0], this.links[1], this.links[2]);
          }
          this.selectedSubmenuArray.length = 0;
          this.links = ['', '', ''];
          this.sidebarOpen = !this.sidebarOpen;
        }
        //this.filterCategory(id,'','', link, '', '')
      },
      filterCategory(category, categorya, categoryb, categoryLink, categoryaLink, categorybLink) {
        //reset search term
        this.$store.commit('SET_CATEGORY_SEARCH_TERM', '');

        this.$store.commit({
          type: 'SET_SELECTED_CATEGORY',
          category: category,
          categorya: categorya,
          categoryb: categoryb,
          categoryLink: categoryLink,
          categoryaLink: categoryaLink,
          categorybLink: categorybLink
        });

        if (categorybLink != '' && categoryaLink != '' && categoryLink != '') {
          this.$router.push({
            name: 'goods-categoryb-page',
            params: { categorylink: categoryLink, categoryalink: categoryaLink, categoryblink: categorybLink }
          });
        } else if (categoryaLink != '' && categoryLink != '') {
          this.$router.push({
            name: 'goods-categorya-page',
            params: { categorylink: categoryLink, categoryalink: categoryaLink }
          });
        } else if (categoryLink != '') {
          this.$router.push({
            name: 'goods-category-page',
            params: { categorylink: categoryLink }
          });
        } else /*if (location.href.indexOf('/goods/') == -1)*/ {
          this.$router.push({
            name: 'goods'
          });
        }
        //else {
        //  var page = 1; //todo, for now results are shown on one page
        //  this.$store.dispatch('loadGood', [page, this.searchTerm, category, categorya, categoryb]);
        //}
      },
    }
  }
</script>

<style scoped>

.item:hover {
    background: rgba(255,255,255,.08)!important;
    color: #fff!important;
    cursor: pointer;
}

  div.sidemenu-open {
    width: 70vw;
    background-color: transparent;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2000;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }

  div.sidebar-closed {
    left: -72vw;
  }

  a.sidebar-menu-button {
    margin-top: 10px;
    position: fixed;
    left: 57vw;
    top: 0;
    z-index: 2000;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    padding: 0px
  }

  a.sidebar-menu-button div span.line {
    background-color: white;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }

  a.sidebar-menu-button div span.line-closed {
    background-color: white;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }

  a.sidebar-menu-button-closed {
    left: 0;
    top: 60px;
  }

  ul.submenu-list li {
    padding: 10px;
    padding-left: 0px;
    list-style: none;
  }

  ul.submenu-list li a {
    color: #fffdfc;
  }

  ul.submenu-level1 {
    position: absolute;
    left: -70vw;
    transition: all 0.3s ease-in-out 0.3s
  }

  ul.submenu-level1.is-active {
    left: 0;
  }

  ul.submenu-level2 {
    position: absolute;
    left: -70vw;
    transition: all 0.3s ease-in-out 0.3s
  }

  ul.submenu-level2.is-active {
    left: 0;
  }

  ul.submenu-level3 {
    position: absolute;
    left: -70vw;
    transition: all 0.3s ease-in-out 0.3s
  }

  ul.submenu-level3.is-active {
    left: 0;
  }

  .hamburger .line {
    width: 30px;
    height: 5px;
    border-radius: 10px;
    background-color: white;
    display: block;
    margin: 4px auto;
    -webkit-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
  }

  .hamburger:hover {
    cursor: pointer;
  }

  #hamburger-6.is-active {
    -webkit-transition: transform 0.3s ease-in-out;
    -o-transition: transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out;
    -webkit-transition-delay: 0.6s;
    -o-transition-delay: 0.6s;
    transition-delay: 0.6s;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);

  }

  #hamburger-6.hide-hamburger {
    background-color: transparent !important;
    box-shadow: 0px 0px 0px 0px !important;
  }

  #hamburger-6.is-active .line:nth-child(2) {
    width: 0px;
    margin: 2px auto;
  }

  #hamburger-6.is-active .line:nth-child(1),
  #hamburger-6.is-active .line:nth-child(3) {
    -webkit-transition-delay: 0.3s;
    -o-transition-delay: 0.3s;
    transition-delay: 0.3s;
    margin: 2px auto;
  }

  #hamburger-6.is-active .line:nth-child(1) {
    -webkit-transform: translateY(6.5px);
    -ms-transform: translateY(6.5px);
    -o-transform: translateY(6.5px);
    transform: translateY(6.5px);
  }

  #hamburger-6.is-active .line:nth-child(3) {
    -webkit-transform: translateY(-6.5px) rotate(90deg);
    -ms-transform: translateY(-6.5px) rotate(90deg);
    -o-transform: translateY(-6.5px) rotate(90deg);
    transform: translateY(-6.5px) rotate(90deg);
  }

  /*
.ui.dropdown .menu .menu{
  left:7px !important;
  top:39px !important;
}
*/

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }

  .fade-enter,
  .fade-leave-active

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }

  ul {
    margin-top: 0px;
    height: 80vh;
    overflow: auto;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// TopMenu.vue?6e6839e8